import React from "react";
import PropTypes from "prop-types";
import H from "../Typography/H";
import HorizontalSlider from "../HorizontalSlider";
import ProductCard from "../ProductCard";
import {generateSliderBreakpoints} from "../../../utils/breakpoints-slider-generator";
import {TILE} from "../../../constants";

import styles from "./product-cards.module.scss";

function ProductCards(props) {
  const {products, title, size = TILE, ga, isProductsApp} = props;
  return products && products.length ? (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        {title}
      </H>
      <div className={styles.content}>
        <HorizontalSlider
          dots={false}
          slidesToScroll={1}
          slidesToShow={6}
          infinite={false}
          lazyLoad='ondemand'
          responsive={generateSliderBreakpoints({size})}
        >
          {products.map((item) => (
            <ProductCard
              key={item.id}
              size={size}
              content={item}
              className={styles.card}
              ga={ga}
              isProductsApp={isProductsApp}
            />
          ))}
        </HorizontalSlider>
      </div>
    </div>
  ) : null;
}

ProductCards.propTypes = {
  products: PropTypes.array,
  title: PropTypes.string,
  isProductsApp: PropTypes.bool
};

export default ProductCards;
